module.exports = __webpack_public_path__ + "media/images/static/top/urban/TO-01c185e91d81de681ad8af478ddd425c.png";